import React, { useState } from "react";
import "./style.css";
import { ReceiptEuro } from "lucide-react";
import { useEffect } from "react";
import axios from "axios";
import { base_url } from "../../config";

function Summary() {
  const [billingHistory, setBillingHistory] = useState([]);

  useEffect(() => {
    window.history.replaceState({}, "", "/");

    const fetchInvoices = async () => {
      try {
        await axios.post(`${base_url}/api/get_billing`).then((response) => {
          setBillingHistory(response.data);
        });
      } catch (error) {
        console.error("Communication Error", error);
      }
    };
    fetchInvoices();

  }, []);

 
  
  return (
    <div className="billing">
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100" style={{ background: "#f8faff" }}>
          <ReceiptEuro size={18} color="#002E78" />
          <span className="font-semibold text-[#002E78]">Payment Receipts</span>
        </div>
        <div className="divide-y divide-gray-100">
          {billingHistory.length === 0 && (
            <p className="px-6 py-4 text-sm text-gray-400">No payments found.</p>
          )}
          {billingHistory.map((order, index) => (
            <div key={index} className="flex justify-between items-center px-6 py-4 flex-col sm:flex-row gap-3">
              <div className="text-gray-800 text-sm">{order.order}</div>
              {order.receiptUrl ? (
                <a
                  href={order.receiptUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="button shrink-0 text-center"
                  style={{ textDecoration: "none", lineHeight: "21px" }}
                >
                  View Receipt
                </a>
              ) : (
                <span className="text-sm text-gray-400">Receipt unavailable</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Summary;
